export type SemanticColor = 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'cyan' | 'rose';

interface ColorVars {
  main: string;
  soft: string;
  line: string;
}

/**
 * CSS-custom-property references for the app's tinted-surface pattern (soft
 * background + translucent border + solid text/icon) — shared by IconTile,
 * Pill, StatusChip, and SoftButton so every colored badge in the app draws
 * from the same palette and adapts to light/dark automatically via the
 * `:root[data-theme="dark"]` overrides in global.css.
 */
export const SEMANTIC_COLOR_VARS: Record<SemanticColor, ColorVars> = {
  primary:   { main: 'var(--color-primary)',     soft: 'var(--color-primary-soft)',      line: 'var(--color-primary-line)' },
  secondary: { main: 'var(--color-secondary)',   soft: 'var(--color-secondary-soft)',    line: 'var(--color-secondary-line)' },
  success:   { main: 'var(--color-success)',     soft: 'var(--color-success-soft)',      line: 'var(--color-success-line)' },
  warning:   { main: 'var(--color-warning)',     soft: 'var(--color-warning-soft)',      line: 'var(--color-warning-line)' },
  error:     { main: 'var(--color-error)',       soft: 'var(--color-error-soft)',        line: 'var(--color-error-line)' },
  cyan:      { main: 'var(--color-accent-cyan)', soft: 'var(--color-accent-cyan-soft)',  line: 'var(--color-accent-cyan-line)' },
  rose:      { main: 'var(--color-accent-rose)', soft: 'var(--color-accent-rose-soft)',  line: 'var(--color-accent-rose-line)' },
};

const HASH_CYCLE: SemanticColor[] = ['cyan', 'secondary', 'success', 'rose', 'warning', 'primary'];

/**
 * Deterministic string → semantic color, cycling through a fixed palette.
 * Used to color-code open-ended, backend-driven category/type labels (entity
 * types, document categories) without hardcoding against specific names.
 */
export function hashSemanticColor(key: string): SemanticColor {
  let hash = 0;
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return HASH_CYCLE[hash % HASH_CYCLE.length];
}
